export default __webpack_public_path__ + "static/Myra-3d956c47a6367e29e405628ca0f5019438a9fc42d0d5c733c9579d389ea8588e.svg";